import { ActivityIndicator } from '@populix/pop-ui'
import { useRouter } from 'next/navigation'
import { MdChevronRight } from 'react-icons/md'

import Toast from '../shared/toast'

import { useAppSelector } from '@/libs/hooks/use-app-selector'
import useEmailVerify from '@/libs/hooks/use-email-verify'

export default function VerifyEmailWarning({ show }: { show: boolean }) {
  const router = useRouter()
  const { partnerId, partnerIdNonIntegration } = useAppSelector((state) => state.user)
  const { isRequestingOtp } = useEmailVerify()

  const onClickVerifyEmail = async () => {
    return router.push('/verify-email')
  }

  return (
    <Toast
      type='warning'
      title='Verify your Email'
      description='To continue answering survey.'
      show={show}
      disableClose
      actionElement={
        <button
          data-testid='btn-verify'
          className='flex items-center justify-center gap-1 rounded-full bg-white px-4 py-[10px] text-pop-blue-700'
          onClick={onClickVerifyEmail}
        >
          {isRequestingOtp && (partnerId || partnerIdNonIntegration) ? (
            <ActivityIndicator size='small' />
          ) : (
            <span className='text-nowrap text-sm font-medium'>Verify Email</span>
          )}
          <MdChevronRight width={20} height={20} className='text-xl' />
        </button>
      }
    />
  )
}
